<template>
    <div class="detialPage">
        <headerNotice :routerName="pageName"></headerNotice>
        <!-- 表头信息 -->
        <div class="detialInfo">
            <el-table
                ref="detialInfoTable"
                border
                :data="detialTableData"
                style="width: 100%"
                class="detialTable"
            >
                <el-table-column :prop="idKey" align="center" :label="userIdLable"></el-table-column>
                <el-table-column :prop="nameKey" align="center" :label="nameLable"></el-table-column>
                <el-table-column
                    v-if="this.nameKey=='customerName'"
                    prop="linkman"
                    align="center"
                    label="联系人"
                ></el-table-column>
                <el-table-column prop="phone" align="center" label="联系手机"></el-table-column>
                <el-table-column :prop="balanceLableName" align="center" :label="lableName"></el-table-column>
            </el-table>
            <!-- 搜索框 -->
            <div class="searchBox">
                <h2 class="searchTitle">
                    <i></i>
                    <span>筛选查询</span>
                </h2>
                <el-form :inline="true" :model="searchForm" class="demo-form-inline searchForm">
                    <el-form-item label="记录类型">
                        <el-select v-model="searchForm.recordType" placeholder="请选择">
                            <el-option
                                v-for="item in recordTypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="操作时间">
                        <el-date-picker
                            v-model="searchForm.createTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择时间"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSearch">查询结果</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 搜索结果列表 -->
            <div class="searchList" v-loading="loading">
                <div class="searchListHead">
                    <h2 class="searchListTitle">
                        <i></i>
                        <span>数据列表</span>
                    </h2>
                    <!-- <div class="searchListCtl">
                        <el-button>导出数据</el-button>
                        已整合到分页
                        <el-select v-model="searchListCtlForm.num" placeholder="显示条数">
                            <el-option label="默认显示数" value></el-option>
                            <el-option label="5条" value="1"></el-option>
                            <el-option label="10条" value="2"></el-option>
                        </el-select>
                        <el-select v-model="searchListCtlForm.arrange" placeholder="排列方式">
                            <el-option label="默认排列方式" value></el-option>
                            <el-option label="按客户名" value="1"></el-option>
                            <el-option label="按业务员" value="2"></el-option>
                        </el-select>
                    </div> -->
                </div>
                <div class="searchListContent">
                    <el-table
                        ref="searchListTable"
                        :data="searchListTableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange"
                        border
                    >
                        <el-table-column align="center" type="index" label='序号' width="55"></el-table-column>
                        <el-table-column prop="recordType" align="center" label="记录类型"></el-table-column>
                        <el-table-column prop="flowValue" align="center" :label="lableName2"></el-table-column>
                        <el-table-column prop="createTime" align="center" label="时间"></el-table-column>
                    </el-table>
                </div>
            </div>
            <!--搜索列表分页-->
            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync='currentPage'
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            ></el-pagination>
        </div>
    </div>
</template>


<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            loading: true,
            totalCount: 0,//总数据条数
            maxResultCount: 10, //默认一页显示的个数,
            currentPage: 1,
            url: '',
            balanceLableName: 'balance',
            nameKey: '',//判断是否显示联系人
            idKey: '',//判断是否显示联系人
            userIdLable: '',
            nameLable: '',
            pageName: '余额明细',
            lableName: '预存款余额',
            lableName2: '余额变化',
            detialTableData: [],
            searchForm: {
                recordType: '0',
                recordDate: '',
                userId: 'userName'
            },
            searchListCtlForm: {
                num: '',
                arrange: ''
            },
            searchListTableData: [],
            searchListSeletion: [],
            recordTypeOptions: [{ value: '0', label: '全部' }, { value: '1', label: '充值' }, { value: '2', label: '消费' }],
            moneyDetialForm: ''
        }
    },
    components: {
        headerNotice
    },
    created() {
        //通过goodID控制页面显示余额或积分
        console.log(this.$route.query.goodsId);
        if (this.$route.query.goodsId == 'balance') {
            this.pageName = '余额明细';
            this.lableName = '预存款余额';
            this.lableName2 = '余额变化';
            this.recordTypeOptions = [{ value: '0', label: '全部' }, { value: '1', label: '充值' }, { value: '2', label: '消费' }];
            this.balanceLableName = 'balance';
            this.url = '/api/services/app/AdminFlowRecord/GetFundRecordList';
        } else {
            this.pageName = '积分明细';
            this.lableName = '积分';
            this.lableName2 = '积分变化';
            this.recordTypeOptions = [{ value: '0', label: '全部' }, { value: '1', label: '平台扣除' }, 
                                        { value: '2', label: '平台增加' }, { value: '3', label: '积分充值' }, 
                                        { value: '4', label: '购物积分' }, { value: '5', label: '积分兑换' }, 
                                        { value: '6', label: '积分赠送' }, { value: '7', label: '积分获赠' }, { value: '8', label: '充值赠送' }];
            this.balanceLableName = 'integral';
            this.url = '/api/services/app/AdminFlowRecord/GetIntegralRecordList';
        }
        if (sessionStorage.getItem('moneyDetialForm')) {
            this.detialTableData.push(JSON.parse(sessionStorage.getItem('moneyDetialForm')))
            console.log(this.detialTableData);
        }
        if (this.detialTableData[0].realName) {
            this.nameKey = 'realName';
            this.idKey = 'userName';
            this.userIdLable = '业务员账号';
            this.nameLable = '业务员名称';
        } else {
            this.nameKey = 'customerName';
            this.idKey = 'userName'
            this.userIdLable = '客户账号';
            this.nameLable = '客户名称';
        }
    },
    mounted() {
        this.getDatas({
            MaxResultCount: this.maxResultCount,
            userId: this.$route.query.userId
        });
        this.searchForm.userId = this.$route.query.userId;
    },
    methods: {
        //获取列表数据
        getDatas(params) {
            let self = this;
            self.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + self.url,
                params: params,
                success(res) {
                    self.searchListTableData = res.items;
                    self.totalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    console.log(res);
                    self.loading = false;
                }
            })
        },
        //搜索
        onSearch(params) {
            let self = this;
            let form = this.searchForm;
            // console.log(form)
            this.getDatas(form)
            this.currentPage = 1
        },
        handleSelectionChange(val) {
            this.searchListSeletion = val;
            console.log(this.searchListSeletion);
        },
        //搜索列表一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
            };
            this.getDatas(params);
        },
        //搜索列表跳转到指定页
        handleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = this.searchForm;
            params.MaxResultCount = this.maxResultCount;
            params.SkipCount = skipCount;
            this.getDatas(params);
        },
    }
}
</script>

<style lang='scss' scoped>
.detialPage {
    //表头信息
    .detialInfo {
        width: 80%;
        margin: 20px 50px;
        .detialTable {
            border: 1px solid #c5c5c5;
        }
        //搜索框
        .searchBox {
            margin: 20px 0;
            border: 1px solid #c5c5c5;
            .searchTitle {
                display: flex;
                align-items: center;
                height: 40px;
                margin-bottom: 10px;
                padding-left: 20px;
                background: #efefef;
                border-bottom: 1px solid #c5c5c5;
                i {
                    width: 24px;
                    height: 24px;
                    background: url("../../assets/imgs/search01.png");
                }
            }
            .searchForm {
                display: flex;
                align-items: center;
                height: 60px;
                padding-left: 20px;
                .el-form-item {
                    margin-bottom: 0;
                }
            }
        }
        //搜索列表
        .searchList {
            // margin: 20px 50px;
            border: 1px solid #c5c5c5;
            .searchListHead {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 40px;
                padding-left: 20px;
                background: #efefef;
                border-bottom: 1px solid #c5c5c5;
                .searchTitle {
                    i {
                        width: 24px;
                        height: 24px;
                        background: url("../../assets/imgs/search02.png");
                    }
                }
                .searchListCtl {
                    button,
                    .el-select {
                        width: 130px;
                        margin-left: 10px;
                    }
                }
            }
            .searchListContent {
                .detialSpan {
                    color: #ff9400;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>